


import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { FaEdit, FaTrash } from 'react-icons/fa';
import InstanceForm from './InstanceForm';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import './InstanceForm.css';
import { useAuth } from '../../context/AuthContext';
import withPermission from '../../utils/withPermission';
import Swal from 'sweetalert2';
import InstanceDetails from './InstanceDetails';

const InstanceList = () => {
    const [instances, setInstances] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedInstanceId, setSelectedInstanceId] = useState(null);
    const [selectedInstanceData, setSelectedInstanceData] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [errors, setErrors] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const debounceTimeoutRef = useRef(null);
    const firstLoad = useRef(true);
    const { roles, permissions } = useAuth();
    const [allInstances, setAllInstances] = useState([]);
    const fetchInstances = async (page = 1) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/instance-info`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
                params: {
                    page: page,
                    search: searchQuery, // Send search query to backend
                },
            });

            const { data, current_page, last_page } = response.data.Data;

            setInstances(data);

            setCurrentPage(current_page - 1);
            setPageCount(last_page);
        } catch (error) {
            console.error('Error fetching instances:', error);
        }
    };



    // useEffect(() => {
    //     if (debounceTimeoutRef.current) {
    //         clearTimeout(debounceTimeoutRef.current);
    //     }

    //     debounceTimeoutRef.current = setTimeout(() => {
    //         fetchInstances(1, searchQuery || ""); 
    //     }, 1500); 
    //     return () => {
    //         if (debounceTimeoutRef.current) {
    //             clearTimeout(debounceTimeoutRef.current); 
    //         }
    //     };
    // }, [searchQuery]);





    useEffect(() => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            fetchInstances(1, searchQuery);
        }, searchQuery ? 1500 : 0);

        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, [searchQuery]);



    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);

    };
    //     const canEdit = permissions.includes('instance-edit');
    //   const canDelete = permissions.includes('instance-delete');
    const WithDeletePermission = withPermission(({ children }) => children, ['instance-delete']);
    const WithEditPermission = withPermission(({ children }) => children, ['instance-edit']);
    const WithCreatePermission = withPermission(({ children }) => children, ['instance-create']);



    const addInstance = async (newInstance) => {

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.post(`${backendUrl}/api/instance-info`, newInstance, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
                skipLoader:true,
            });
            const createdInstance = response.data?.Data[0];

            if (createdInstance) {
                setInstances((prevInstances) => [...prevInstances, createdInstance]);
            } else {
                console.error('Creation failed, no data returned.');
            }

            handleCloseModal(); // Close modal after adding
              Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: 'Added successfully!',
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });

        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors; // Return validation errors
            } else {
                console.error('Error adding instance:', error);
            }
        }
    };


    const editInstance = async (instanceId, updatedData) => {

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.put(`${backendUrl}/api/instance-info/${instanceId}`, updatedData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
                skipLoader:true,
            });
            const updatedInstance = response.data?.Data;

            if (updatedInstance) {
                setInstances((prevInstances) =>
                    prevInstances.map((instance) =>
                        instance.id === updatedInstance.id ? updatedInstance : instance
                    )
                );
            } else {
                console.error('Update failed, no data returned.');
            }

            handleCloseModal();
             Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: 'Updated successfully!',
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors; // Return validation errors
            } else {
                console.error('Error updating instance:', error);
            }
        }
    };

    const deleteInstance = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const backendUrl = process.env.REACT_APP_BACKEND_URL;

                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');
                    const token = userInfo?.token;

                    await axios.delete(`${backendUrl}/api/instance-info/${id}`, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Tenant-Origin': origin,

                        },
                    });

                    setInstances(instances.filter(instance => instance.id !== id));
                    Swal.fire(
                        "Deleted!",
                        "The instance has been deleted.",
                        "success"
                    );
                } catch (error) {
                    console.error('Error deleting instance:', error);
                    Swal.fire(
                        "Error!",
                        "Failed to delete instance. Please try again.",
                        "error"
                    );
                }
            }
        });
    };

    const handleShowModal = (instanceId = null) => {

        if (instanceId) {
            const instanceToEdit = instances.find(instance => instance.id === instanceId);
            if (instanceToEdit) {
                setSelectedInstanceData(instanceToEdit);
            }
        } else {
            setSelectedInstanceData(null);
        }
        setSelectedInstanceId(instanceId);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedInstanceId(null);
        setSelectedInstanceData(null);
        setErrors({});
    };

    const handlePageClick = (data) => {
        const selectedPage = data.selected + 1;
        fetchInstances(selectedPage);
    };
    const [showLeadOffcanvas, setShowLeadOffcanvas] = useState(false);

    const handleShowLeadDetails = (leadId) => {
        setSelectedInstanceId(leadId);
        setShowLeadOffcanvas(true);
    };

    const handleCloseLeadDetails = () => {
        setShowLeadOffcanvas(false);
        setSelectedInstanceId(null);
    };
    const handleImport = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const formData = new FormData();
            formData.append('file', file);

            const response = await axios.post(
                `${backendUrl}/api/instance-info/import`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                        'Tenant-Origin': origin,
                    },
                }
            );

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: response.data.message || ` Imported successfully!`,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });

            // Refresh the list after import
            setTimeout(() => window.location.reload(), 1000);

            // Clear the file input
            event.target.value = '';

        } catch (error) {
            console.error('Import error:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: error.response?.data?.errors || error.response?.errors || `Failed to import instance information`,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });
            event.target.value = "";

        } finally {
        }
    };

    // Export Functions
    const handleExport = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(
                `${backendUrl}/api/instance-info/export`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                    responseType: 'blob', // Important for file download
                }
            );

            // Create blob link and download
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            // Get filename from response headers or use default
            const contentDisposition = response.headers['content-disposition'];
            let filename = `instance_${new Date().toISOString().split('T')[0]}.xlsx`;

            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
                if (filenameMatch.length === 2) {
                    filename = filenameMatch[1];
                }
            }

            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: `Exported successfully!`,
                timer: 2000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });

        } catch (error) {
            console.error('Export error:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: `Failed to export`,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });
        } finally {
        }
    };
    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    {/* Page Title */}

                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">Instances</h4>

                            </div>
                        </div>
                    </div>

                    {/* Instance Table */}
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    {/* <div className="d-flex justify-content-end mb-3"> */}
                                    <div className="d-flex justify-content-between mb-3">
                                        <div className="d-flex">
                                            <div className="search-box me-2 mb-2 d-inline-block">
                                                <div className="position-relative">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search..."
                                                        value={searchQuery}
                                                        onChange={handleSearchChange}
                                                    />
                                                    <i className="bx bx-search-alt search-icon" />
                                                </div>
                                            </div>



                                        </div>
                                        <div className="d-flex align-items-center gap-2">
                                            {/* Export Button */}
                                            <button
                                                type="button"
                                                className="btn btn-light border"
                                                onClick={handleExport}
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Export"
                                            >
                                                <i className="mdi mdi-file-excel text-success"></i>
                                            </button>

                                            {/* Import Button */}
                                            <input
                                                type="file"
                                                accept=".xlsx, .xls"
                                                id="importLeadsFile"
                                                onChange={handleImport}
                                                style={{ display: "none" }}
                                            />
                                            <label
                                                htmlFor="importLeadsFile"
                                                className="btn btn-light border mb-0"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Import"
                                            >
                                                <i className="mdi mdi-upload text-primary"></i>
                                            </label>

                                            {/* Add Button */}
                                            <WithCreatePermission>
                                                <button
                                                    type="button"
                                                    className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"
                                                    onClick={() => handleShowModal()}
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title='Add Instance'
                                                >
                                                    <i className="mdi mdi-plus"></i>
                                                </button>
                                            </WithCreatePermission>
                                        </div>
                                        {/* <WithCreatePermission>
                                            <button
                                                type="button"
                                                className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"

                                                onClick={() => handleShowModal()} // Updated line
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Add Instance"
                                            >
                                                <i className="mdi mdi-plus" ></i>
                                            </button>
                                        </WithCreatePermission> */}
                                    </div>
                                    {/* Table */}
                                    <div>
                                        <table className="table align-middle table-nowrap table-check table-list">

                                            <thead className="table-sales-gradient">
                                                <tr>
                                                    <th style={{ width: '20px' }} className="align-middle">
                                                        <div className="form-check font-size-16">
                                                            <input className="form-check-input" type="checkbox" id="checkAll" />
                                                            <label className="form-check-label" htmlFor="checkAll"></label>
                                                        </div>
                                                    </th>
                                                    <th className="align-middle">#</th>
                                                    <th style={{ textAlign: 'left' }}>Setup Name</th>

                                                    <th className="align-middle" style={{ textAlign: 'right' }}>Setup ID</th>
                                                    <th className="align-middle">Setup Mode</th>

                                                    <th className="align-middle">Setup Type</th>
                                                    <th className="align-middle">Contact Type</th>
                                                    <th className="align-middle">Status</th>
                                                    <th className="align-middle">No.of Tenants</th>

                                                    <th className="align-middle">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {instances.length > 0 ? (
                                                    instances.map((instance, index) => (
                                                        <tr key={instance.id}>
                                                            <td>
                                                                <div className="form-check font-size-16">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id={`instanceCheck${index}`}
                                                                    />
                                                                    <label
                                                                        className="form-check-label"
                                                                        htmlFor={`instanceCheck${index}`}
                                                                    ></label>
                                                                </div>
                                                            </td>
                                                            <td>{index + 1}</td>

                                                            <td style={{ textAlign: 'left' }}>
                                                                <button
                                                                    onClick={() => handleShowLeadDetails(instance.id)} // Pass lead ID
                                                                    className="dropdown-item"
                                                                >
                                                                    {instance.setup_name}
                                                                </button>
                                                            </td>
                                                            <td style={{ textAlign: 'right' }}>
                                                                {instance.setup_id} </td>
                                                            <td>{instance.setup_mode}</td>

                                                            <td>{instance.setup_type}</td>
                                                            <td>{instance.contact_type}</td>
                                                            <td>{instance.active_status}</td>
                                                            <td>{instance.tenants_count || 0}</td>

                                                            <td>
                                                                {/* Action buttons for Edit and Delete */}
                                                                <div className="dropdown">
                                                                    <i
                                                                        className="mdi mdi-dots-horizontal font-size-18"
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="false"
                                                                        style={{ cursor: 'pointer' }}
                                                                    ></i>
                                                                    <ul className="dropdown-menu dropdown-menu-end font-size-14" >
                                                                        <li>
                                                                            <button
                                                                                onClick={() => handleShowLeadDetails(instance.id)} // Pass lead ID
                                                                                className="dropdown-item"
                                                                            >                                                                                View Details
                                                                            </button>
                                                                        </li>
                                                                        <li>
                                                                            {/* {canEdit && ( */}
                                                                            <WithEditPermission>

                                                                                <button
                                                                                    className="dropdown-item"
                                                                                    onClick={() => handleShowModal(instance.id)}
                                                                                >
                                                                                    Edit
                                                                                </button>
                                                                            </WithEditPermission>

                                                                            {/* )}  */}
                                                                        </li>
                                                                        <li>
                                                                            {/* <WithDeletePermission> */}

                                                                            {/* {canDelete && ( */}
                                                                            <WithDeletePermission>

                                                                                <button
                                                                                    className="dropdown-item"
                                                                                    onClick={() => deleteInstance(instance.id)}
                                                                                >
                                                                                    Delete
                                                                                </button>
                                                                            </WithDeletePermission>

                                                                            {/* )}  */}
                                                                        </li>

                                                                    </ul>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="9">No instances found</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                        {/* <div className="d-flex justify-content-between align-items-center mt-3">
                                            <span style={{fontSize:'12px',color:'#6e6e6e'}}>Showing 1 to 10 of {instances.length} entries</span> */}
                                        <div className="d-flex justify-content-end pagination-sm">
                                            <ReactPaginate
                                                previousLabel={'<'}
                                                nextLabel={'>'}
                                                breakLabel={'...'}
                                                pageCount={pageCount}
                                                marginPagesDisplayed={2}
                                                pageRangeDisplayed={3}
                                                onPageChange={handlePageClick}
                                                containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                                pageClassName={'page-item'}
                                                pageLinkClassName={'page-link'}
                                                previousClassName={'page-item previous'}
                                                previousLinkClassName={'page-link'}
                                                nextClassName={'page-item next'}
                                                nextLinkClassName={'page-link'}
                                                breakClassName={'page-item'}
                                                breakLinkClassName={'page-link'}
                                                activeClassName={'active'}
                                            />
                                        </div>
                                        {/* </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <InstanceForm
                        key={selectedInstanceId || 'new'}
                        showModal={showModal}
                        handleClose={handleCloseModal}
                        instanceId={selectedInstanceId}
                        instanceData={selectedInstanceData}
                        addInstance={addInstance}
                        editInstance={editInstance}
                        instances={instances}
                        errors={errors}
                        setErrors={setErrors}
                        allInstances={allInstances}


                    />
                    <InstanceDetails
                        show={showLeadOffcanvas}
                        onHide={handleCloseLeadDetails}
                        instanceId={selectedInstanceId}
                    // onOrganisationUpdate={fetchOrganisation} // Pass refresh function if needed
                    />
                </div>
            </div>
        </div>
    );
};

export default InstanceList;







